"use client";

import "./globals.css";
import { useEffect } from "react";
import { captureMarketingException } from "@/lib/marketing-analytics-client";

import { StatusPageCard } from "@/components/site/primitives/status-page-card";

export default function GlobalError({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  useEffect(() => {
    console.error(error);

    captureMarketingException(error, {
      error_boundary: "global",
      error_source: "error_boundary",
      route_name:
        typeof window !== "undefined" ? window.location.pathname || "/" : "unknown",
      digest: error.digest ?? null,
    });
  }, [error]);

  return (
    <html lang="en" className="h-full scroll-smooth antialiased">
      <body className="min-h-screen bg-background text-foreground">
        <title>Application error | Cooperly</title>
        <meta name="robots" content="noindex" />
        <StatusPageCard
          eyebrow="Application error"
          title="The site hit an unexpected root-level error."
          description="This is a technical failure state, not missing content. Retry once, and if it persists, come back to the homepage and re-open the page from there."
          primaryAction={{
            href: "/",
            label: "Return home",
          }}
          secondaryAction={{
            href: "/partner-program",
            label: "View partner program",
          }}
        >
          <button
            type="button"
            onClick={() => unstable_retry()}
            className="inline-flex h-11 items-center justify-center rounded-md border border-input bg-background px-8 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground"
          >
            Retry application
          </button>
        </StatusPageCard>
      </body>
    </html>
  );
}
